import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, blue } from '../colors';

export const infoColor = (mode: PaletteMode): ChronosphereColorPalette => {
  return mode === 'light'
    ? {
        main: blue[500],
        highContrast: blue[700],
        lowContrast: blue[100],
      }
    : {
        main: blue[400],
        highContrast: blue[100],
        lowContrast: blue[800],
      };
};
